const config = {
  //API_URL : 'https://uatapi.beatmyinsurance.com/api'
   // API_URL: 'https://api.beatmyinsurance.com/api',
    API_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000/webapi',
  };
  
  export default config;
  